export const styles = (theme) => ({
  table: {
    width: '100%'
  },
  createBottlesDetailTable: {
    width: 650
  },
  dateOfArrival: {
    width: 200
  },
  storagePlace: {
    width: 300
  },
  storageLocation: {
    width: 300
  },
  expiration: {
    width: 150
  },
  buttonCol: {
    paddingTop: theme.spacing(2),
    textAlign: 'right'
  },
  right: {
    textAlign: 'right'
  }
})
